<template lang="html">

  <section class="comunicaciones" v-if="data.length != 0">
    <h1>Comunicaciones</h1>

    <div class="comunicaciones-list container -xs">


      <article class="comunicacion" v-for="(el,key) in data" :haslink="!!el.enlace">

        <main>

          <h5 class="fecha">{{el.fechaDesde}}</h5>

          <h2>{{el.descripcion}}</h2>

          <a :href="el.enlace" target="_blank" v-if="!!el.enlace" class="link">Ver más</a>

        </main>

      </article>

    </div>


  </section>

</template>

<script lang="js">

    import {mapActions} from 'vuex';

    export default  {
      name: 'comunicaciones',
      mounted(){
        setTimeout(e => {
          this.requestComunicaciones().then( r =>{
            this.data = r;
          })
        },200)
        
      },
      data(){
        return{
          data : ''
        }
      },
      methods: {
         ...mapActions(['requestComunicaciones'])
      },
  }
  </script>
<style scoped lang="scss">
    .comunicaciones {
  
    }
  </style>


// WEBPACK FOOTER //
// src/components/parts/comunicaciones.vue